var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "#C125AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9474 40.0571V21.8947C40.9474 20.8484 40.099 20 39.0526 20C38.0063 20 37.1579 20.8484 37.1579 21.8947V40.0571L30.9188 33.818C30.1787 33.0783 28.9792 33.0783 28.2391 33.818C27.4994 34.5582 27.4994 35.7576 28.2391 36.4977L39.0526 47.3113L49.8662 36.4977C50.6059 35.7576 50.6059 34.5582 49.8662 33.818C49.126 33.0783 47.9266 33.0783 47.1865 33.818L40.9474 40.0571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8947 44.6309C24.9411 44.6309 25.7895 45.4793 25.7895 46.5256V49.5572C25.7895 51.0222 26.9771 52.2098 28.4421 52.2098H49.6632C51.1282 52.2098 52.3158 51.0222 52.3158 49.5572V46.5256C52.3158 45.4793 53.1642 44.6309 54.2105 44.6309C55.2569 44.6309 56.1053 45.4793 56.1053 46.5256V49.5572C56.1053 53.1153 53.2213 55.9993 49.6632 55.9993H28.4421C24.8844 55.9993 22 53.1153 22 49.5572V46.5256C22 45.4793 22.8484 44.6309 23.8947 44.6309Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.99e739579569e2e3931708b936448b0f.svg";
export { ForwardRef as ReactComponent };